import {
  takeEvery,
  call,
  put,
} from 'redux-saga/effects'
import axios from 'axios'
import Router from 'next/router'

import {
  Types,
  retrieveCartSuccess,
  retrieveCartError,
  addProductSuccess,
  addProductError,
} from '../ducks/cart'

function* fetchCartItems() {
  try {
    const items = yield call(axios, {
      method: 'GET',
      url: '/shopping-cart/all',
      headers: {
        'origin-local': 'http://joaoemaria.caseme.local',
      },
    })

    yield put(retrieveCartSuccess(Object.keys(items.data.params.presents)))
  } catch (err) {
    yield put(retrieveCartError(err))
  }
}

function* addProduct({ payload }) {
  try {
    yield call(axios, {
      method: 'POST',
      url: '/shopping-cart/add',
      data: { present_id: payload },
      headers: {
        'origin-local': 'http://joaoemaria.caseme.local',
      },
    })
    yield put(addProductSuccess())
    Router.push('/checkout/cart')
  } catch (err) {
    yield put(addProductError(err))
  }
}

export default function* () {
  yield takeEvery(Types.RETRIEVE_CART, fetchCartItems)
  yield takeEvery(Types.ADD_PRODUCT, addProduct)
}
